import {
  isAddendumBackPayItem,
  isBackPayItem,
} from "../../../../Finance/Payroll/helper-payroll/constants/payrollConstants";

export const payrollCaseRegistry = {
  isBasicGeneral: ({ payrollType = "", payItem = "" }) =>
    payrollType === "Basic Pay" && payItem === "General Payroll",

  isBasicAddendum: ({ payrollType = "", jobType = "", payItem = "" }) =>
    payrollType === "Basic Pay" &&
    jobType !== "Job Order" &&
    payItem === "Addendum Payroll",

  isBasicBackpay: ({ payrollType = "", payItem = "" }) =>
    payrollType === "Basic Pay" && isAddendumBackPayItem(payItem),

  isApGeneralNewly: ({ payrollType = "", payItem = "" }) =>
    payrollType === "Augmentation Pay" &&
    (payItem === "General Payroll" || payItem === "Newly-Hired"),

  isBasicJoSalary: ({ payrollType = "", jobType = "", payItem = "" }) =>
    payrollType === "Basic Pay" &&
    jobType === "Job Order" &&
    payItem === "Salary",

  isBasicJoAddendum: ({ payrollType = "", jobType = "", payItem = "" }) =>
    payrollType === "Basic Pay" &&
    jobType === "Job Order" &&
    isBackPayItem(payItem),

  isSeventhCase: ({ payrollTypes = "", jobTypeVal = "", payItems = "" }) =>
    payrollTypes === "IP" &&
    jobTypeVal !== "Job Order" &&
    (payItems === "Initial" || payItems === "Last"),
  isEightCase: ({ payrollTypes = "", jobTypeVal = "", payItems = "" }) =>
    payrollTypes === "IP" &&
    (payItems === "Initial AP" || payItems === "Last AP"),
  isNinthCase: ({ payrollTypes = "", payItems = "" }) =>
    payrollTypes === "IP" && payItems === "Rata",
  isTenthCase: ({ payrollTypes = "", payItems = "" }) =>
    payrollTypes === "IP" && payItems === "SalaryDiffBasic",
  isEleventhCase: ({ payrollTypes = "", jobTypeVal = "", payItems = "" }) =>
    payrollTypes === "IP" &&
    jobTypeVal === "Job Order" &&
    (payItems === "Initial" || payItems === "Last"),
  isApBackPay: ({ payrollType, payItem }) =>
    payrollType === "Augmentation Pay" && isBackPayItem(payItem),
  isTirteenthCase: ({ payrollTypes = "", payItems = "" }) =>
    payrollTypes === "SP",
};
